import { connect } from 'react-redux'
import * as React from 'react'
import to from 'await-to-js'
// @ts-ignore
import { Button } from 'relevant-ui'
import {
  getApplications,
  setCurrentApp,
  updateApplication,
  createApplication,
  deleteApp,
} from '@App/store/application/actions'
import './styles.scss'
import UiPage from '@App/components/blocks/UiPage'
import AppForm from '@App/components/forms/ApplicationForm'
import { Props, DispatchProps, State, IFormatedApp } from './types'
import { toggleFieldAction } from '@App/store/toggleField'
import { getFormValues } from 'redux-form'
import { Fields } from '@App/components/forms/ApplicationForm/types'
import Modal from '@App/components/blocks/Modal'
import ModalConfirm from '@App/components/blocks/Modal/ModalConfirm'
import { ModalType, ModalSize, setShowModal, setHideModal } from '@App/store/modal'
import { withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { IApplication } from '@App/store/application/types'

class ApplicationsPage extends React.Component<Props, State> {
  static renderList(el) {
    return {
      id: el?.id,
      title: el?.name,
      subtitle: el?.url.split('//')[1],
      url: el?.url,
      segments: el?.segments,
    }
  }

  constructor(props: any) {
    super(props)

    this.state = {
      deleteApp: 0,
      search: '',
    }

    props.getApplications()

    this.onHandleSubmit = this.onHandleSubmit.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDeleteApp = this.handleDeleteApp.bind(this)
  }

  componentDidMount() {
    const { list, setCurrentApp } = this.props
    const first = ApplicationsPage.renderList(list[0])

    setCurrentApp(first)
  }

  async onHandleSubmit(e, segments) {
    e.preventDefault()
    const {
      toggleFieldAction,
      current,
      appFormValues,
      updateApplication,
      createApplication,
    } = this.props

    const body = {
      ...appFormValues,
      segments,
    }

    if (current) {
      const [, data] = await to(updateApplication(current.id, body))
      if ((data as any).id) {
        return toggleFieldAction(true)
      }
      return toggleFieldAction(false)
    }

    const [, data] = await to(createApplication(body))
    if ((data as any).id) {
      return toggleFieldAction(true)
    }
    return toggleFieldAction(false)
  }

  handleClick() {
    const { toggleFieldAction, setCurrentApp } = this.props

    toggleFieldAction(false)
    setCurrentApp(null)
    return
  }

  handleDelete(e) {
    e.preventDefault()

    this.setState({ deleteApp: this.props.current.id })
    return this.props.setShowModal(ModalType.DELETE)
  }

  handleDeleteApp() {
    this.props.deleteApp(this.state.deleteApp)
    return this.props.setHideModal()
  }

  render() {
    const {
      list,
      setHideModal,
      setCurrentApp,
      toggleFieldAction,
      current,
      t,
    } = this.props

    const appList: IFormatedApp[] = list?.filter(
      (item: any) => item.name !== 'Retargeting',
    ).map((el: IApplication) => ApplicationsPage.renderList(el))

    return (
      <div style={{ height: '100%' }}>
        <UiPage
          title="Applications"
          search={t('search_app')}
          button={t('new_app')}
          data={appList?.filter((el: IFormatedApp) => el.title.toLowerCase().includes(this.state.search.toLowerCase())) || []}
          handleClick={this.handleClick}
          handleSearch={(e: any) => this.setState({ search: e.target.value })}
          setCurrent={(e: IFormatedApp) => setCurrentApp(e)}
          withHeader
        >
          <AppForm
            handleSubmit={(e: any, data: any) => this.onHandleSubmit(e, data)}
            handleCancel={() => toggleFieldAction(true)}
            handleDelete={this.handleDelete}
          />
        </UiPage>

        <Modal
          type={ModalType.DELETE}
          size={ModalSize.SMALL}
          handleClose={() => { }}
        >
          <ModalConfirm
            title={'Supprimer Application'}
            description={`Etes vous sur de vouloir supprimer l'application: ${current?.title}`}
            handleCancel={setHideModal}
            handleConfirm={this.handleDeleteApp}
          />
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    getApplications: () => dispatch(getApplications()),
    toggleFieldAction: (bool: boolean) => dispatch(toggleFieldAction(bool)),
    setCurrentApp: (app: any) => dispatch(setCurrentApp(app)),
    updateApplication: (id, body) => dispatch(updateApplication(id, body)),
    createApplication: (body: any) => dispatch(createApplication(body)),
    setHideModal: () => dispatch(setHideModal()),
    deleteApp: (id: number) => dispatch(deleteApp(id)),
    setShowModal: (type: any) => dispatch(setShowModal(type)),
  }
}

const mapStateToProps = (state: any) => {
  const appFormValues = getFormValues(Fields.FORM)(state)
  const {
    applications: { list, current },
  } = state

  return {
    list,
    current,
    appFormValues,
  }
}
export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(ApplicationsPage)
